import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '@optsolservices/ngx-notification';
import { BaseService } from 'src/app/core/services/base.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { PosStoreService } from '../../pos.store.service';

@Component({
  selector: 'app-sales-order-ecom-stock-code-search-dialog',
  templateUrl: './sales-order-ecom-stock-code-search-dialog.component.html',
  styleUrls: ['./sales-order-ecom-stock-code-search-dialog.component.scss']
})
export class SalesOrderEcomStockCodeSearchDialogComponent implements OnInit {
  selectedStockCode: any = null;

  constructor(
    private dialogRef: MatDialogRef<SalesOrderEcomStockCodeSearchDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private posStoreService: PosStoreService,
  ) { }

  ngOnInit() {
    console.log(this.data);
  }

  add() {
    if (this.data.mode === 'SYSPRO') {
      const dialogData: OiGroupDialogData = {
        title: 'Adding line to the order in SYSPRO',
        function: 'portal_oi_group_syspro_order_add_line',
        postBody: {
          salesOrderNumber: this.data.salesOrderNumber,
          stockCode: this.selectedStockCode.stockCode,
          qty: 1
        }
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0) {
          this.notificationService.success('Line Added');
        }
      });

    } else {
      this.baseService.executeCommand<any[]>('portal_sales_order_add_stock_code', {
        salesOrderHeaderId: this.data.salesOrderHeaderId,
        stockCode: this.selectedStockCode.stockCode,
        qty: 1
      })
        .subscribe(response => {
          if (response.responseCode === 0) {

            this.posStoreService.notifySalesOrderChanged({
              salesOrderHeaderId: this.data.salesOrderHeaderId,
              source: 'SalesOrderScanStockCodeDialogComponent'
            });
          }
        });
    }
  }

  stockCodeSelected(event: any) {
    this.selectedStockCode = event;
  }

  close() {
    this.dialogRef.close(true);
  }
}
